import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../../../common/html/element'
import { Tooltip } from '../../../../../../../../../common/tooltip'
import { valToPercent } from '../../../../../../../../../helpers/value'
import classes from './index.module.scss'

export const RangeScoreLevel = ({ data, idRange, scoreValue, rangeScore }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <>
      {data
        .filter((key) => key.id !== 0)
        .map((item, index) => (
          <div key={index} className="flex1 w100">
            <Tooltip
              contentStyle={{ width: '100%', height: '100%' }}
              tooltipContent={
                <CustomRenderToolTip
                  item={rangeScore[item.id] || 0}
                  locale={locale}
                />
              }
            >
              <Element
                key={item.color}
                className="minW0 textCenter fw600 w100 h100"
                style={{
                  padding: '3px 0',
                  backgroundColor: item.color,
                  color: '#191D25',
                  fontSize: 24,
                  opacity: index === 4 - idRange ? 1 : 0.5,
                }}
              >
                {index === 4 - idRange && scoreValue}
              </Element>
            </Tooltip>
          </div>
        ))}
    </>
  )
}

const CustomRenderToolTip = ({ item, locale }) => {
  return (
    <>
      <Element
        elementName="p"
        style={{
          fontWeight: 600,
          paddingBottom: 6,
          borderBottom: '1px solid #3F4145',
        }}
      >
        {item.scoreRangeName}
      </Element>
      <table className={` ${classes.table} w100`}>
        <tbody>
          <tr>
            <td>
              <Translate value="score.premium.TABLE.PERFORMANCE" />
            </td>
            <td>{`${item.scoreRange_Min} - ${item.scoreRange_Max}`}</td>
          </tr>
          <tr>
            <td>
              <Translate value="score.premium.DESCRIPTION" />
            </td>
            <td>{item.scoreRangeDescription}</td>
          </tr>
          <tr>
            <td>
              <Translate value="score.premium.TOOLTIP_PER_12M" />
            </td>
            <td>{`${valToPercent(
              item.forecastProbability_Min_12M,
              locale,
              0,
              0,
              1,
            )} - ${valToPercent(
              item.forecastProbability_Max_12M,
              locale,
              0,
              0,
              1,
            )}`}</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
